// extracted by css-extract-rspack-plugin
export default {"clickable":"RT4nNd","spacer":"qn3K4M","sideControls":"G1OjJD","compass":"VTmP4j"};